import { Tooltip } from 'react-tooltip'

export const capFirstChar = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

const limit = (str: string, limit: number, showTooltip = false, limitDots = false): any => {
    if (showTooltip) {
        return str.length > limit ? <>
            <span data-tooltip-id={str}>{str.substring(0, limit)}{limitDots ? '..': '...'}</span>
            <Tooltip
                id={str}
                place="top-start"
                content={str}
                style={{left: 0, top: 0, zIndex: 999999}}
            />
        </> : str;
    }

    return str.length > limit ? `${str.substring(0, limit)}${limitDots ? '..' : '...'}` : str;
}

const exportObject = {
    capFirstChar,
    limit
};

export default exportObject;